import * as React from 'react';

import css from './PasswordForgot.module.scss';

export const PasswordForgot = (props: { message: string }) => {
  return (
    <div className={css.PasswordForgot}>
      <a href="/password/forgot">{props.message}</a>
    </div>
  );
};
